/**
 * A 2D canvas sized for one pixel readback: an `OffscreenCanvas` where the
 * runtime has one and it gives a 2D context, a DOM canvas otherwise, its
 * context already fetched. Null where neither could be made.
 */
export function readableCanvas2d(
  width: number, height: number, willReadFrequently = true,
): {
  canvas: OffscreenCanvas | HTMLCanvasElement;
  ctx: CanvasRenderingContext2D | OffscreenCanvasRenderingContext2D;
} | null {
  if (typeof OffscreenCanvas === 'function') {
    const canvas = new OffscreenCanvas(width, height);
    const ctx = canvas.getContext('2d', { willReadFrequently });
    if (ctx) return { canvas, ctx };
  }
  if (typeof document === 'undefined') return null;
  const canvas = Object.assign(document.createElement('canvas'), { width, height });
  const ctx = canvas.getContext('2d', { willReadFrequently });
  return ctx ? { canvas, ctx } : null;
}
